import { createAction, props } from "@ngrx/store";
import { PaginationRequest } from "src/app/models/common/paginationRequest";

export const resetDeliveriesState = createAction(
  "[Delivery] Reset Deliveries State Action"
);
export const resetDebitState = createAction(
  "[Delivery] Reset Debits State Action"
);
export const getDeliveries = createAction(
  "[Delivery] Get All Deliveries Action",
  props<{ options: any }>()
);
export const loadDeliveries = createAction(
  "[Delivery] Load All Deliveries Action",
  props<{ response: any[] }>()
);
export const getMeasurements = createAction(
  "[Delivery] Get All Measurements Action",
  props<{ options: any }>()
);
export const loadMeasurements = createAction(
  "[Delivery] Load All Measurements Action",
  props<{ response: any[] }>()
);
export const getDebits = createAction(
  "[Delivery] Get All Debits Action",
  props<{ options: any }>()
);
export const loadDebits = createAction(
  "[Delivery] Load All Debits Action",
  props<{ response: any[] }>()
);
export const getDeliveriesExcel = createAction(
  "[Delivery] Get All Deliveries Excel Action",
  props<{ options: any }>()
);
export const loadDeliveriesExcel = createAction(
  "[Delivery] Load All Deliveries Excel Action",
  props<{ response: any[] }>()
);
export const getMeasurementsExcel = createAction(
  "[Delivery] Get All Measurements Excel Action",
  props<{ options: any }>()
);
export const loadMeasurementsExcel = createAction(
  "[Delivery] Load All Measurements Excel Action",
  props<{ response: any[] }>()
);
export const getDebitExcel = createAction(
  "[Delivery] Get All Debit Excel Action",
  props<{ options: any }>()
);
export const loadDebitExcel = createAction(
  "[Delivery] Load All Debit Excel Action",
  props<{ response: any[] }>()
);

// Deliveries / Measurements / Debits Table Configuration Settings
export const getDeliveriesTableConfig = createAction(
  "[Delivery] Get Fuel Stock Deliveries Table Configuration Action",
  props<{ options: any }>()
);
export const loadDeliveriesTableConfig = createAction(
  "[Delivery] Load Fuel Stock Deliveries Table Configuration Action",
  props<{ response: any[] }>()
);
export const getMeasurementsTableConfig = createAction(
  "[Delivery] Get Fuel Stock Measurements Table Configuration Action",
  props<{ options: any }>()
);
export const loadMeasurementsTableConfig = createAction(
  "[Delivery] Load Fuel Stock Measurements Table Configuration Action",
  props<{ response: any[] }>()
);
export const getDebitsTableConfig = createAction(
  "[Delivery] Get Fuel Stock Debits Table Configuration Action",
  props<{ options: any }>()
);
export const loadDebitsTableConfig = createAction(
  "[Delivery] Load Fuel Stock Debits Table Configuration Action",
  props<{ response: any[] }>()
);
export const saveTableConfig = createAction(
  "[Delivery] Save Fuel Stock Deliveries / Measurements Table Configuration Action",
  props<{ config: any }>()
);

export const loadDeliveriesFailure = createAction(
  "[Delivery] Deliveries Load Action Failure",
  props<{ error: Error }>()
);
export const updateDelivery = createAction(
  "[Delivery] Update Delivery Action",
  props<{ delivery: any }>()
);
export const getDelivery = createAction(
  "[Delivery] Get Delivery Action",
  props<{ delivery: any }>()
);
export const loadDelivery = createAction(
  "[Delivery] Load Delivery Action",
  props<{ response: any }>()
);
export const setDelivery = createAction(
  "[Delivery] Set Delivery Action",
  props<{ delivery: any }>()
);

export const getProduct = createAction(
  "[Delivery] Get Product Action",
  props<{ warehouseCode: string; pageReq?: PaginationRequest }>()
);
export const loadProduct = createAction(
  "[Delivery] Load Product Action",
  props<{ response: any[] }>()
);

export const createDelivery = createAction(
  "[Delivery] Create Delivery Action",
  props<{ delivery: any }>()
);
export const loadDeliveriesLoadStart = createAction(
  "[Delivery] Load Delivery Start Action"
);
export const loadDeliveriesLoadEnd = createAction(
  "[Delivery] Load Delivery End Action"
);
export const loadProductLoadStart = createAction(
  "[Delivery] Load Product Start Action"
);
export const loadProductLoadEnd = createAction(
  "[Delivery] Load Product End Action"
);
export const loadDeliveryLoadStart = createAction(
  "[Delivery] Load Delivery Start Action"
);
export const loadDeliveryLoadEnd = createAction(
  "[Delivery] Load Delivery End Action"
);
export const resetDelivery = createAction("[Delivery] Reset Delivery Action");
export const resetMeasurement = createAction(
  "[Measurement] Reset Measurement Action"
);
export const resetCreation = createAction("[Delivery] Reset Creation Action");
